import { useEffect, useState } from "react"
import {
  CategoryOutlined as CategoryOutlinedIcon,
  Lock as LockIcon,
} from "@mui/icons-material"
import { Alert, AlertTitle } from "@mui/material"

import CategoriesTable from "./CategoriesTable"
import CategoriesModal from "./CategoriesModal"
import DeleteCategoryModal from "./DeleteCategoryModal"
import { useCategories } from "./useCategories"
import { getCategoriesConfig } from "../../../services/settings-config"
import { getEnterprise } from "../../../services/scout"
import { isAccountBlocked, renderAIFeatures } from "../../../services/utils"

const CategoriesPage = () => {
  const {
    items,
    editing,
    deleting,
    setEditing,
    setDeleting,
    save,
    remove,
  } = useCategories()

  const [enterprise, setEnterprise] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [shouldRenderContent, setShouldRenderContent] = useState(false)

  const isBlocked = isAccountBlocked(enterprise) || !shouldRenderContent

  useEffect(() => {
    const loadEnterprise = async () => {
      const data = await getEnterprise()
      setEnterprise(data)
      setShouldRenderContent(renderAIFeatures(data))
    }

    void loadEnterprise()
  }, [])

  const config = getCategoriesConfig()

  const handleEdit = (item) => {
    if (isBlocked) return
    setEditing(item)
    setShowModal(true)
  }

  const handleAdd = () => {
    if (isBlocked) return
    setEditing(null)
    setShowModal(true)
  }

  const handleDelete = (item) => {
    if (isBlocked) return
    setDeleting(item)
  }

  const handleSave = async (payload) => {
    if (isBlocked) return false
    const ok = await save(payload)
    if (ok) {
      setShowModal(false)
      setEditing(null)
    }
    return ok
  }

  const handleRemove = async (item) => {
    if (isBlocked) return false
    const ok = await remove(item)
    if (ok) {
      setDeleting(null)
    }
    return ok
  }

  return (
    <>
      {shouldRenderContent
        ? <section className="scout-settings-section">
          <div className="scout-settings-section__label">
            <CategoryOutlinedIcon />
            <span>{config?.sectionLabel || "Categorias de contatos"}</span>
          </div>

          <Alert severity="info" style={{ marginBottom: 16 }}>
            <AlertTitle>
              Categorias são usadas para classificar automaticamente os contatos monitorados pelo Scout.
            </AlertTitle>
          </Alert>

          <CategoriesTable
            items={items}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onAdd={handleAdd}
            disabled={isBlocked}
          />
        </section>
        : <Alert severity="info" icon={<LockIcon fontSize="inherit" />}>
          <AlertTitle>Recurso indisponível no seu plano.</AlertTitle>
        </Alert>
      }

      {showModal && !isBlocked ? (
        <CategoriesModal
          open={showModal}
          onClose={() => {
            setShowModal(false)
            setEditing(null)
          }}
          initialValue={editing}
          onSubmit={handleSave}
          submitLabel={editing ? "Salvar" : "Criar"}
        />
      ) : null}

      {!isBlocked ? (
        <DeleteCategoryModal
          open={Boolean(deleting)}
          item={deleting}
          onClose={() => setDeleting(null)}
          onConfirm={handleRemove}
        />
      ) : null}
    </>
  )
}

export default CategoriesPage
